import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Typography, Stack, Tab, Tabs, Button, Tooltip } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import {
  useGetUserPermissionsQuery,
  useGetFeatureModulesQuery,
  useSetUserPermissionsMutation,
  useSetSingleUserPermissionsMutation,
  useRevokeSingleUserPermissionsMutation,
} from '../userApiSlice';
import {
  selectModules,
  selectSelectedFeatures,
  setSelectedFeatures,
  setModules,
  selectUserProfile,
  selectGrantButtonsDisabled,
  selectRevokeButtonsDisabled,
  setRevokeButtonDisabled,
  setGrantButtonDisabled,
} from '../userSlice';
import FeaturePanel from './FeaturePanel';
import { TabContext } from '@mui/lab';
import SettingsHeader from './SettingsHeader';
import { CheckCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

const SettingsTab = ({ empCode }) => {
  const dispatch = useDispatch();
  const { data: permissionsData, refetch } = useGetUserPermissionsQuery(empCode, {
    skip: !empCode,
    refetchOnMountOrArgChange: true,
  });
  const { data: modulesData } = useGetFeatureModulesQuery();
  const selectedPermissions = useSelector(selectSelectedFeatures);
  const modules = useSelector(selectModules);
  const [value, setValue] = useState('1');
  const [grantPermission] = useSetSingleUserPermissionsMutation();
  const [revokeSingleUserPermission] = useRevokeSingleUserPermissionsMutation();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const grantDisabled = useSelector(selectGrantButtonsDisabled)
  const revokeDisabled = useSelector(selectRevokeButtonsDisabled)

  useEffect(() => {
    if (permissionsData?.data?.permissions && modulesData) {
      const permissions = permissionsData.data.permissions.map((p) => p._id);
      dispatch(setSelectedFeatures({ signal: true }));

      let updatedModules = JSON.parse(JSON.stringify(modulesData.data));

      updatedModules.forEach((module) => {
        module.features.forEach((feat) => {
          feat.checked = permissions.includes(feat.permission);
          if (permissions.includes(feat.permission)) {
            dispatch(setSelectedFeatures({ module: module.name, featId: feat.permission, type: 'add' }));
          }
        });
      });

      dispatch(setModules(updatedModules));
    } else if (modulesData) {
      dispatch(setModules(modulesData.data));
    }
  }, [modulesData, permissionsData, dispatch]);

  // useEffect(()=>{
  //   setButtonDisabled(false)
  // },[selectedPermissions])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleGrantPermission = () => {
    grantPermission({
      user: empCode,
      permissions: selectedPermissions,
    });
    dispatch(setGrantButtonDisabled(true))
  };

  const handleRevokePermission = () => {
    console.log('selectedPermissions', empCode, [...new Set(selectedPermissions)]);
    revokeSingleUserPermission({
      empCode,
      permissions: [...new Set(selectedPermissions)],
    });
    dispatch(setRevokeButtonDisabled(true))
  };

  return (
    <Stack sx={{ p: 1 }}>
      <TabContext value={value}>
        <Stack direction="row" sx={{ height: 'calc(100vh - 320px)', border: 0, justifyContent: 'center' }}>
          <Box sx={{ border: 0, flex: 0.25 }}>
            <Typography sx={{ mb: 1 }}>Select a module</Typography>
            <Tabs
              sx={{ height: '100%' }}
              value={value}
              onChange={handleChange}
              orientation="vertical"
              variant={'scrollable'}
              scrollButtons={'auto'}
              allowScrollButtonsMobile
            >
              {Object.keys(modules).map((mod, index) => (
                <Tab
                  key={index}
                  label={mod}
                  value={String(index + 1)}
                  sx={{ display: 'flex', alignItems: 'flex-start' }}
                />
              ))}
            </Tabs>
          </Box>
          {Object.keys(modules).map((mod, index) => (
            <FeaturePanel module={mod} key={index} value={String(index + 1)} features={modules[mod]} />
          ))}
        </Stack>
        <Stack sx={{ mt:"-40px",ml: 'auto' }} spacing={1}>
          <Tooltip placement="top-start" title="This will keep the permissions which is selected.">
            <Button
            disabled={revokeDisabled}
              size="small"
              variant="outlined"
              sx={{
                ml: 'auto',
                minWidth: '205px',

                '&:hover': { borderColor: 'error.dark', color: 'error.light' },
              }}
              // disabled={grantDisabled}
              startIcon={<RemoveCircleOutline sx={{ marginLeft: '5px' }} />}
              onClick={handleRevokePermission}
            >
              Revoke permissions
            </Button>
          </Tooltip>
          <Button
          disabled={grantDisabled}
            size="small"
            variant="contained"
            sx={{
              ml: 'auto',
              minWidth: '205px',
              alignItems: 'center',
              justifyContent: 'start',
              // backgroundColor: 'success.main',
              // '&:hover': { backgroundColor: 'success.dark' },
            }}
            // disabled={grantDisabled}
            startIcon={<CheckCircleOutline sx={{ marginLeft: '5px' }} />}
            onClick={handleGrantPermission}
          >
            Grant permissions
          </Button>
        </Stack>
        {/* <Button
          size='small'
          variant='contained'
          sx={{
            ml: 'auto',
            minWidth: '205px',
            alignItems: 'center',
            justifyContent: 'start',
            marginTop: 'auto',
            // backgroundColor: 'success.main',
            // '&:hover': { backgroundColor: 'success.dark' },
          }}
          startIcon={<CheckCircleOutline sx={{ marginLeft: '5px' }} />}
          onClick={handleGrantPermission}
        >
          Grant permissions
        </Button> */}
      </TabContext>
    </Stack>
  );
};

export default SettingsTab;
